export default {
  title: {
    id: 'bo_sellers-orders-drawers-financial-details-no-data-title',
    defaultMessage: 'This order has no cost summary available.',
  },
  subtitle: {
    id: 'bo_sellers-orders-drawers-financial-details-no-data-surtitle',
    defaultMessage: 'Oops!',
  },
} as const
